<template>
  <v-card class="calendar-card rounded">
    <div class="py-1 calendar-menu">
      <v-btn text @click="pushDate(today, 'month')" class="pl-3 py-2">
        <h2 id="current-month">{{currentMonth}}</h2>
      </v-btn>
      <span>
        <v-btn
          :title="$store.state.user.langEng ? 'Todays date' : 'Dagens datum'"
          icon
          @click="goToToday()"
        >
          <v-icon>today</v-icon>
        </v-btn>
        <v-btn small icon @click.prevent="prev()">
          <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>
        <v-btn small icon @click.stop="next()">
          <v-icon>keyboard_arrow_right</v-icon>
        </v-btn>
      </span>
    </div>
    <event-dialog @editEvent="edit($event)" />
    <v-calendar
      ref="calendar"
      v-model="today"
      :type="type"
      :locale="$store.state.user.langEng ? 'en-US' : 'sv-SE'"
      :interval-format="intervalFormat"
      :show-month-on-first="false"
      :events="events"
      :event-color="getEventColor"
      :event-margin-bottom="2"
      :event-height="17"
      event-name="title"
      @click:event="showEvent"
      @click:date="pushDate"
      @click:more="pushDate"
      @click:time.self="addTimeEvent"
      event-more-text="<p style='font-size: .7em; text-align: start;'>⚫⚫⚫</p>"
      :weekdays="[1, 2, 3, 4, 5, 6, 0]"
      color="primary"
    ></v-calendar>
    <div class="align-items-center pt-5">
      <v-radio-group class="row justify-content-center m-0" @change="changeType" v-model="type" row>
        <v-radio
          v-for="t in typeOptions"
          class="ml-2"
          :key="t.value"
          color="primary"
          :label="t.text"
          :value="t.value"
        ></v-radio>
      </v-radio-group>
    </div>
  </v-card>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import EventDialog from "./EventDialog";
import $ from "jquery";
import { Rest } from '@/utils'

function dateToString(date = new Date()) {
  return date.toLocaleDateString('sv-SE');
}

function dateTimeToString(date = new Date()) {
  return date.toLocaleString('sv-SE');
}

@Component({
  components: {
    EventDialog
  }
})
export default class MyCalendar extends Vue {
  type = "month";
  today = dateToString();
  typeOptions = [
    { text: this.$store.state.user.langEng ? "Day" : "Dag", value: "day" },
    { text: this.$store.state.user.langEng ? "Week" : "Vecka", value: "week" },
    { text: this.$store.state.user.langEng ? "Month" : "Månad", value: "month" }
  ];
  event = {};
  displayingEvent = false

  @Watch("$route.params", { immediate: true })
  routeParams(p) {
    this.setDate(p);
  }

  async showEvent(e) {
    this.displayingEvent = true
    if (e.event._id) {
      const editEvent = await Rest.get('CalendarEvent/' + e.event._id, {        eager: {
          schools: true,
          klasses: true,
          courses: true,
          users: true
        }      });
      this.$store.commit("calendar/setEditEvent", editEvent);
    } else {
      this.$store.commit("calendar/setEditEvent", e.event);
    }
    this.$store.commit('calendar/toggleActiveEvent', true)
    this.displayingEvent = false
  }

  addTimeEvent({ date, time }) {
    if (this.displayingEvent) return

    let start = new Date(date + "T" + time);
    start.setMinutes(0);
    start = start.getTime();

    this.$store.commit("calendar/setEditEvent", {
      start: start,
      end: start + 1800000
    })
    this.edit();
  }

  get toggleAddEvent() {
    return this.$store.state.calendar.showAddEventDialog;
  }

  getEventColor(event) {
    return event.color;
  }

  goToToday() {
    this.today = dateToString();
    this.pushDate(this.today, this.type);
  }

  setDate(p) {
    if (!p || !p.year || !p.view) {
      const date = new Date();
      p = {
        view: 'month',
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
      };
    }
    this.type = p.view;
    this.today = `${p.year}-${p.month}-${p.day}`;
    this.scrollDay();
    setTimeout(() => {
      this.checkSunday();
    }, 5);
  }

  changeType() {
    this.pushDate(this.today, this.type);
    this.scrollDay();
  }

  pushDate(day, view = "day") {
    this.type = view;

    const date = new Date(day.date || day);
    const d = {
      view: view,
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    };
    this.$router.push({
      name: "calendar",
      params: d
    });
  }

  sortDate(date, allday) {
    let times = [];
    this.events[date] &&
      Object.values(this.events[date]).forEach(value => times.push(value));
    times = times.sort((a, b) => a[0].start - b[0].start);

    if (allday === undefined) return times;
    else if (allday)
      return times.map(arrays => arrays.filter(event => event.allday));
    else if (!allday)
      return times.map(arrays => arrays.filter(event => !event.allday));

    return times;
  }

  scrollDay() {
    if (this.type === "day" || this.type === "week") {
      setTimeout(() => {
        this.$refs.calendar && this.$refs.calendar.scrollToTime("08:00");
      }, 5);
    }
  }

  async edit() {
    this.$store.commit("calendar/toggleAddEventDialog", true);
  }

  get isMobile() {
    return this.$store.state.isMobile;
  }

  changeDate(next) {
    let dt = new Date(this.today);

    if (this.type === "day") {
      dt.setDate(next ? dt.getDate() + 1 : dt.getDate() - 1);
    } else if (this.type === "week") {
      dt.setDate(next ? dt.getDate() + 7 : dt.getDate() - 7);
    } else if (this.type === "month") {
      dt.setMonth(next ? dt.getMonth() + 1 : dt.getMonth() - 1);
    }
    this.pushDate(dateToString(dt), this.type);
    if (next) this.$refs.calendar.next();
    else this.$refs.calendar.prev();
  }

  next() {
    this.changeDate(true);
  }

  prev() {
    this.changeDate(false);
  }

  intervalFormat(interval) {
    return interval.time;
  }

  get currentMonth() {
    let enMonths = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ];
    let sweMonths = [
      "Januari",
      "Februari",
      "Mars",
      "April",
      "Maj",
      "Juni",
      "Juli",
      "Augusti",
      "September",
      "Oktober",
      "November",
      "December"
    ];
    let month = new Date(this.today).getMonth();
    return this.$store.state.user.langEng ? enMonths[month] : sweMonths[month];
  }

  get events() {
    return this.$store.state.calendar.events.map(e => {
      // removes time on all day events
      if(e.allDay) {
        e.start = dateToString(new Date(e.start))
        e.end = dateToString(new Date(e.end))
      } else {
        e.start = dateTimeToString(new Date(e.start))
        e.end = dateTimeToString(new Date(e.end))
      }
      return e
    });
  }

  created() {
    if (!this.$route.params.day) {
      // set calendar params
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      this.$router.replace(`/calendar/month/${year}/${month}/${day}`);
    }
  }

  checkSunday() {
    // v-calendar-daily__head
    let weeks = $(".v-calendar-weekly__week");
    for (let week of weeks) {
      let weekend = $(week)
        .children()
        .last();
      weekend.find(".v-btn__content").addClass("red-day");
    }
    let weeksHead = $(".v-calendar-daily__head");
    for (let week of weeksHead) {
      let weekend = $(week)
        .children()
        .last();
      if (weekend.text().includes("sön") || weekend.text().includes("sun")) {
        weekend.find(".v-calendar-daily_head-weekday").addClass("red-day");
        weekend.find(".v-btn__content").addClass("red-day");
      }
    }
  }
}
</script>

<style lang="scss">
.calendar-card {
  min-height: 70vh;
  min-width: 100%;
  #current-month {
    cursor: pointer;
    font-size: 2em;
  }
  .calendar-menu {
    display: flex;
    justify-content: space-between;
  }
  .v-calendar {
    max-height: 50vh;
    &.v-calendar-monthly {
      border-top: 1px solid #e0e0e0;
      border-left: 1px solid #e0e0e0;
    }
    .v-past {
      .v-btn {
        color: #ccc !important;
      }
    }
  }
  .calendar-type {
    margin: 0;
    display: inline-block !important;
  }
  .v-calendar-weekly__day,
  .v-calendar-daily_head-day,
  .v-calendar-weekly__head-weekday {
    &:last-child:not(:nth-child(2)),
    .red-day {
      color: red !important;
    }
  }
  .v-calendar-daily_head-weekday {
    padding: 0;
  }
  .v-calendar-weekly__day-label {
    height: 25px;
    margin: 0;
    .v-btn {
      width: 2em;
      height: 2em;
    }
  }
  .v-calendar-daily_head-day-label {
    font-size: 2em;
    text-align: center;
    padding: 0;
    .v-btn {
      width: 2em;
      height: 2em;
    }
  }
  .v-calendar-weekly__week {
    .v-event {
      font-size: 0.7em;
      height: 16px;
      strong {
        display: none;
      }
    }
  }
  .v-calendar-daily__intervals-body,
  .v-calendar-daily__intervals-head {
    width: 2.5em;
  }
}
.day-events {
  overflow-y: auto;
  height: 5vh;
}
.my-event {
  overflow: hidden;
  white-space: nowrap;
  border-radius: 2px;
  color: #ffffff;
  width: 100%;
  font-size: 10px;
  padding: 0 1px;
  cursor: pointer;
  margin-bottom: 1px;
  &.with-time {
    position: absolute;
    padding: 2px;
    border: 1px solid #fff;
  }
}
@media (max-width: 900px) and (orientation: landscape) {
  .calendar-card {
    min-height: 115vh;
    .v-calendar {
      max-height: 83vh;
    }
  }
}
</style>
